import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean } from "../../utils/strings";
class UpcomingProductV1 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    const { featuredProduct, loading, lang, pageConfig } = this.props.appData;
    const productConfig =
      pageConfig?.product?.settings?.translations?.[lang] || {};
    const bgPath = clean(
      pageConfig?.product?.settings?.cover || "assets/img/bg/22.jpg"
    );
    const cover = fileUrl(API_FILE_URL, bgPath);
    const featuredProducts = Array.isArray(featuredProduct?.products)
      ? featuredProduct.products
      : [];
    // Eğer loading durumunda, featuredProduct yoksa veya products array'i boşsa hiçbir şey render etme
    if (loading || !featuredProduct || featuredProducts.length === 0) {
      return null;
    }

    return (
      <div
        className="ltn__upcoming-project-area section-bg-1--- bg-image-top pt-115"
        data-bs-bg={cover}
        style={{ backgroundImage: `url(${cover})`, backgroundSize: "cover" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center---">
                <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color--- white-color">
                  {productConfig?.subtitle || "Yeni Ürünler"}
                </h6>
                <h1 className="section-title  white-color">
                  {productConfig?.title || "Doğa Dostu E-Series"}
                </h1>
              </div>
            </div>
          </div>
          <div className="row ltn__upcoming-project-slider-1-active slick-arrow-3">
            {featuredProducts.map((item, i) => {
              const t =
                item?.translations?.[lang] ||
                item?.translations?.tr ||
                item?.translations?.en ||
                {};
              const mainCategory = item?.mainCategory;
              const mainCategorySlug = item?.mainCategorySlug;
              const mainCategoryTranslations =
                item?.mainCategoryTranslations?.[lang];
              const mainCategoryName = mainCategoryTranslations?.name || null;

              const name = clean(t.name);
              const table = clean(t.table);
              const bgPath = clean(item?.cover);
              const bg = bgPath ? fileUrl(API_FILE_URL, bgPath) : null;

              return (
                <div className="col-lg-12">
                  <div className="ltn__upcoming-project-item">
                    <div className="row align-items-center">
                      <div className="col-lg-4">
                        <div className="ltn__upcoming-project-img animated slideInRight">
                          <img
                            src={bg || publicUrl + "assets/img/product-3/3.jpg"}
                            alt="#"
                            style={{
                              borderRadius: "6px",
                            }}
                          />
                        </div>
                        <div className="ltn__upcoming-project-info ltn__menu-widget p-0 pt-2 animated slideInRight">
                          <strong className="ltn__secondary-color">
                            <Link
                              to={{
                                pathname: "/urunler",
                                state: { categoryId: mainCategory },
                              }}
                            >
                              {mainCategoryName || "Kategori"}
                            </Link>
                          </strong>
                          <h3>{name || "Ürün Adı"}</h3>
                          <div className="btn-wrapper">
                            <Link
                              to={`/urunler/${item.slug}`}
                              className="underline-link"
                            >
                              {lang === "tr" ? "Ürünü İncele" : "View Product"}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8 section-bg-1">
                        <div
                          className="ltn__upcoming-project-info ltn__menu-widget px-0 py-3"
                          dangerouslySetInnerHTML={{
                            __html: (table || "")
                              .replace(/<p>\s*&nbsp;\s*<\/p>/gi, "")
                              .replace(/<p>\s*<\/p>/gi, "")
                              .replace(/<p>&nbsp;<\/p>/gi, ""),
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default withAppData(UpcomingProductV1);
